import { render, staticRenderFns } from "./DialogEditarFaq.vue?vue&type=template&id=0d460e02&"
import script from "./DialogEditarFaq.vue?vue&type=script&lang=js&"
export * from "./DialogEditarFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports